export default {
  meta: {
    title: '最新月每日客流趋势',
    url: '/flowfullscreen', // 埋点字段，上报归属的模块
    urlName: '最新月每日客流趋势' // 埋点字段，上报归属的模块
  }
};
